import { render, staticRenderFns } from "./bindTemplate.vue?vue&type=template&id=609c97c0&scoped=true"
import script from "./bindTemplate.vue?vue&type=script&lang=js"
export * from "./bindTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c97c0",
  null
  
)

export default component.exports